import { render, staticRenderFns } from "./FilterClassTree.vue?vue&type=template&id=636550ad&scoped=true&"
import script from "./FilterClassTree.vue?vue&type=script&lang=js&"
export * from "./FilterClassTree.vue?vue&type=script&lang=js&"
import style0 from "./FilterClassTree.vue?vue&type=style&index=0&id=636550ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636550ad",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCol,VForm,VRow,VSelect})
